import ascending from "./ascending";
import bisector from "./bisector";

var ascendingBisect = bisector(ascending);
export var bisectRight = ascendingBisect.right;
export var bisectLeft = ascendingBisect.left;
export default bisectRight;



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/bisect.js
// module id = 401
// module chunks = 4